import React, { useEffect, useState } from "react";
import { Button, Select, DatePicker } from "antd";
import moment from "moment";
import AppInput from "../../../../components/AppInput";
import VoyageDetails from "../../../../components/VoyageDetails";
import { ApiURL } from "../../../../services/apiConstants";
import { post } from "../../../../services/services";
import { ErrorToast, SuccessToast } from "../../../../widgets/AppToast";
import { useNavigate } from "react-router-dom";
import useUserData from "../../../../hooks/useUserData";

const { Option } = Select;

function AddBunkerDelivery() {
  const navigate = useNavigate();
  const user = useUserData();
  const designation = user?.data?.designation;
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [loader, set_loader] = useState(false);
  const [form, setForm] = useState({
    bunkerRefNo: "",
    bunkerDate: moment().format("YYYY-MM-DD"),
    bdnRefNo: "",
    sampleOrigin: "",
    marpolSealNo: "",
    lopIssued: "",
    lopCopyTo: "",
    lopCopyOther: "",
    remarks: "",
    chiefEngSignDigital: "",
    dateSampleDestroyed: null,
    chiefEngSign: "",
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_staff_dashboard(parsedData);
  }, []);

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
    setErrors((prev) => ({ ...prev, [key]: "" }));
  };

  const SEND_NOTIFICATION_MASTER = async (record_id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("voyage_id", staff_dashboard?.voyage_details?.[0]?.id);
      FORM_DATA.append("record_id", record_id);
      FORM_DATA.append(
        "description",
        "A new sulphur delivery note record has been created. Please review and confirm it at your earliest convenience"
      );
      const response = await post(
        ApiURL?.sulphur_bdn_requests_notification_st,
        FORM_DATA
      );
      if (response?.status === true) {
        SuccessToast(
          "Congratulations!",
          response?.message || "No message returned."
        );
      } else {
        ErrorToast("Error", response?.message || "Something went wrong.");
      }
    } catch (error) {
      ErrorToast(
        "Request Failed",
        "Could not complete the request. Please try again."
      );
    }
  };

  const handleSubmit = () => {
    set_loader(true);
    try {
      const formData = new FormData();
      formData.append("voyage_id", staff_dashboard?.voyage_details[0]?.id);
      formData.append("bunker_ref_no", form.bunkerRefNo || "");
      formData.append("bunker_date", form.bunkerDate || "");
      formData.append("bdn_ref_no", form.bdnRefNo || "");
      formData.append("sample_origin", form.sampleOrigin || "");
      formData.append("marpol_seal_no", form.marpolSealNo || "");
      formData.append("lop_issued", form.lopIssued || "");
      formData.append("lop_copy_to", form.lopCopyTo || "");
      formData.append("lop_copy_other", form.lopCopyOther || "");
      formData.append("remarks", form.remarks || "");
      formData.append("chief_eng_sign_digital", form.chiefEngSignDigital || "");
      if (form.dateSampleDestroyed) {
        formData.append(
          "date_sample_destroyed",
          form.dateSampleDestroyed.format("YYYY-MM-DD")
        );
      }
      formData.append("chief_eng_sign", form.chiefEngSign || "");

      post(ApiURL?.add_bunker_delivery_st_bdn, formData)
        .then((res) => {
          const responseData = res?.response?.data || res;
          if (responseData?.status === true) {
            SuccessToast(
              "Success message!",
              "Adding Bunker delivery note has been successful"
            );
            navigate("/list-bunker-delivery-note");
            if (designation && designation !== "Chief Engineer") {
              SEND_NOTIFICATION_MASTER(responseData?.id);
            }
            set_loader(false);
          } else {
            let newErrors = responseData?.errors || {};
            if (responseData?.error && typeof responseData.error === "string") {
              // Try to map specific date errors
              if (responseData.error.toLowerCase().includes("date_sample_destroyed")) {
                newErrors.dateSampleDestroyed = responseData.error;
              }
              if (responseData.error.toLowerCase().includes("bunker_date")) {
                newErrors.bunkerDate = responseData.error;
              }
            }
            setErrors(newErrors);
            if (Object.keys(newErrors).length === 0) {
              ErrorToast("Error", responseData?.message || responseData?.error || "Check your details.");
            }
            set_loader(false);
          }
        })
        .catch((error) => {
          set_loader(false);
          ErrorToast("Error", "Server side error occurred.");
          console.error("Error while submitting bunker details:", error);
        });
    } catch (error) {
      set_loader(false);
      console.error("Unexpected error in handleSubmit:", error);
    }
  };

  return (
    <>
      <VoyageDetails staff_dashboard={staff_dashboard?.voyage_details} />
      <div className="white-container">
        <h3>Bunker Delivery Form</h3>
        <br />
        <div className="row">
          <div className="col-6">
            <AppInput
              label="Bunker Ref. No"
              value={form.bunkerRefNo}
              onChange={(e) => handleChange("bunkerRefNo", e.target.value)}
            />
          </div>
          <div className="col-6">
            <AppInput
              type="date"
              label="Bunker Date"
              value={form.bunkerDate}
              onChange={(e) => handleChange("bunkerDate", e.target.value)}
              errors={errors.bunker_date || errors.bunkerDate}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <AppInput
              label="BDN Ref. No"
              value={form.bdnRefNo}
              onChange={(e) => handleChange("bdnRefNo", e.target.value)}
            />
          </div>
          <div className="col-6">
            <label>Sample Origin (Supplier/Ship)</label>
            <Select
              value={form.sampleOrigin}
              onChange={(value) => handleChange("sampleOrigin", value)}
              placeholder="Select origin"
              style={{ width: "100%" }}
            >
              <Option value="Supplier">Supplier</Option>
              <Option value="Ship">Ship</Option>
              <Option value="Both">Supplier & Ship both</Option>
            </Select>
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <AppInput
              label="MARPOL Sample Seal No."
              value={form.marpolSealNo}
              onChange={(e) => handleChange("marpolSealNo", e.target.value)}
            />
          </div>
          <div className="col-6">
            <label>LOP Issued</label>
            <Select
              value={form.lopIssued}
              onChange={(value) => handleChange("lopIssued", value)}
              placeholder="Select"
              style={{ width: "100%" }}
            >
              <Option value="Yes">Yes</Option>
              <Option value="No">No</Option>
            </Select>
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <label>LOP Copy To</label>
            <Select
              // mode="multiple"
              value={form.lopCopyTo}
              onChange={(value) => handleChange("lopCopyTo", value)}
              placeholder="Select recipients"
              style={{ width: "100%" }}
            >
              <Option value="Supplier">Supplier</Option>
              <Option value="PSC">PSC</Option>
              <Option value="Vessel">Vessel</Option>
              <Option value="Flag">Flag</Option>
              <Option value="Others">Others</Option>
            </Select>
          </div>
          {form.lopCopyTo.includes("Others") && (
            <div className="col-6">
              <AppInput
                label="LOP Copy - Specify Others"
                value={form.lopCopyOther}
                onChange={(e) => handleChange("lopCopyOther", e.target.value)}
              />
            </div>
          )}
        </div>

        <div className="row ">
          <div className="col-6">
            <AppInput
              label="Remarks (if any)"
              value={form.remarks}
              onChange={(e) => handleChange("remarks", e.target.value)}
            />
          </div>
          <div className="col-6">
            <AppInput
              label="Chief Eng. Name & Sign (Digital)"
              value={form.chiefEngSignDigital}
              onChange={(e) =>
                handleChange("chiefEngSignDigital", e.target.value)
              }
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <label>Date Sample Destroyed (if - 12 months)</label> <br />
            <DatePicker
              style={{ width: "100%" }}
              type="date"
              label="Date Sample Destroyed (if - 12 months)"
              value={form.dateSampleDestroyed}
              onChange={(date) => handleChange("dateSampleDestroyed", date)}
            />
            {errors.date_sample_destroyed || errors.dateSampleDestroyed ? (
              <span style={{ color: "red" }}>
                {errors.date_sample_destroyed || errors.dateSampleDestroyed}
              </span>
            ) : null}
          </div>
          <div className="col-6">
            <AppInput
              label="Chief Eng. Name & Sign"
              value={form.chiefEngSign}
              onChange={(e) => handleChange("chiefEngSign", e.target.value)}
              errors={errors.chief_eng_sign || errors.chiefEngSign}
            />
          </div>
        </div>

        <div className="input-box mt-3">
          <Button loading={loader} type="primary" onClick={handleSubmit}>
            Save
          </Button>
        </div>
      </div>
    </>
  );
}

export default AddBunkerDelivery;
